var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.443,
    height: 31.363,
    viewBox: "0 0 27.443 31.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M64.3,0H52.535a4.084,4.084,0,0,0-3.92,3.92l-1.133.026a3.925,3.925,0,0,0-3.767,3.894v19.6a4.084,4.084,0,0,0,3.92,3.92h14.7a4.084,4.084,0,0,0,3.92-3.92h.98a4.084,4.084,0,0,0,3.92-3.92V7.864Zm-1.96,29.4h-14.7a2.055,2.055,0,0,1-1.96-1.96V7.841a1.943,1.943,0,0,1,1.867-1.928l1.073-.032V23.522a4.084,4.084,0,0,0,3.92,3.92H64.3A2.055,2.055,0,0,1,62.336,29.4ZM69.2,23.522a2.055,2.055,0,0,1-1.96,1.96h-14.7a2.055,2.055,0,0,1-1.96-1.96V3.92a2.055,2.055,0,0,1,1.96-1.96h9.8c-.016,2.257,0,3.945,0,3.945a4.038,4.038,0,0,0,3.92,3.9H69.2ZM66.256,7.841c-1.044,0-1.96-1.9-1.96-2.914V1.989l4.9,5.852Zm-1.96,5.9H55.475a.979.979,0,1,0,0,1.958H64.3a.979.979,0,1,0,0-1.958Zm0,4.9H55.475a.979.979,0,1,0,0,1.958H64.3a.979.979,0,1,0,0-1.958Z",
    transform: "translate(-43.714)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyicon);
export default __webpack_public_path__ + "static/media/copyicon.cf965006aa4ba2bd8f6dc3649ee02e75.svg";
export { ForwardRef as ReactComponent };